import '../../../common/dashboard/filters/filter.js.coffee'

Namespace 'CustomerVisualMode.Filters'

class CustomerVisualMode.Filters.HierarchicalTagsAttributeFilter extends Common.Dashboard.Filters.Filter
  @FILTER_TYPE: 'hierarchical_tags'
  removable: true

  constructor: ({attribute, values}) ->
    @attribute = attribute
    @values = values

  getCode: ->
    @attribute.get('code')

  getFilterType: ->
    CustomerVisualMode.Filters.HierarchicalTagsAttributeFilter.FILTER_TYPE

  getName: ->
    @attribute.get('name')

  translatedFilterType: ->
    @getName()

  getAttribute: ->
    @attribute

  getValues: ->
    tags = @attribute.getHierarchicalTagCollection()
    @values.map (value) => name: @hierarchyPath(value, tags).join(' > '), code: value

  hierarchyPath: (value, tags) ->
    path = tags.pathTo(value)
    path.map (level) -> level.get('description')
